import axios from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { REQUEST_MASTER_USER, SET_MASTER_USER, ERROR_GET_MASTER_USER } from './userActionTypes';

function* requestMasterUser(action: Record<string, any>): any {
  try {
    const result: any = yield call(getAppListMaster);
    yield put({ type: SET_MASTER_USER, payload: result.data.data });
  } catch (error: any) {
    let message = 'Something went wrong, please try again after some time or Refresh the Page.';
    if (error?.response?.status === 500) {
      message = 'Something happened wrong try again after sometime.';
    } else if (error?.response?.status === 422) {
      message = error.response.data.message || 'please provide valid contain';
    } else if (error?.response?.status === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_USER, payload: message });
  }
}

export function getAppListMaster() {
  // Auth here comes from the global Authorization header set by
  // utils/setAuth.js after login, not a cookie - the backend never issues
  // one (see auth flow), so `withCredentials` was dead weight that only
  // widened the cross-origin credential surface for no benefit.
  return axios({
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_REACT_APP_BASE_URL1}/user`,
  });
}

const userMasterSaga = function* () {
  yield all([takeLatest(REQUEST_MASTER_USER, requestMasterUser)]);
};

export default userMasterSaga;
